import React from "react";

// Input numérico con un texto (moneda, %, etc.) en un bloque propio, separado del
// input y de sus flechas nativas de incremento/decremento para que nunca se superpongan.
export default function NumberFieldAddon({
  value,
  onChange,
  addon,
  addonPosition = "left",
  className = "",
  inputClassName = "",
  ...inputProps
}) {
  return (
    <div
      className={`flex items-stretch rounded-lg border border-gray-300 bg-white overflow-hidden focus-within:ring-2 focus-within:ring-indigo-400 ${className}`}
    >
      {addon && addonPosition === "left" && (
        <span className="flex items-center px-3 bg-gray-50 text-gray-500 text-sm border-r border-gray-300 select-none whitespace-nowrap">
          {addon}
        </span>
      )}
      <input
        type="number"
        value={value}
        onChange={onChange}
        className={`flex-1 min-w-0 p-3 outline-none ${inputClassName}`}
        {...inputProps}
      />
      {addon && addonPosition === "right" && (
        <span className="flex items-center px-3 bg-gray-50 text-gray-500 text-sm border-l border-gray-300 select-none whitespace-nowrap">
          {addon}
        </span>
      )}
    </div>
  );
}
